import { InjectionToken } from '@angular/core';
import { ListService } from '@abp/ng.core';

export const SECONDARY_LIST = new InjectionToken<ListService>('SECONDARY_LIST');